import styled from "styled-components";

const c = {
  ink: "#ffffff",
  muted: "rgba(255,255,255,0.75)",
  gold: "#c9a227",
  pink: "#fc9ac4",

  cardBg: "#2a2a2d",
  cardBorder: "rgba(201,162,39,0.28)",
  cardBorderPink: "rgba(252,154,196,0.18)",

  shellBg: "#fbfbfb",
  shellBorder: "rgba(201,162,39,0.55)",
};

export const Wrap = styled.section`
  padding: clamp(30px, 5vw, 64px) 16px 70px;
`;

export const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: clamp(28px, 4vw, 44px);
  border-radius: 28px;
  background: ${c.shellBg};
  border: 2px solid ${c.shellBorder};
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    inset: 10px;
    border-radius: 22px;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    border-radius: 22px;

    &::after {
      inset: 8px;
      border-radius: 18px;
    }
  }
`;

export const Head = styled.header`
  text-align: center;
  padding: 8px 0 26px;
`;

export const Title = styled.h3`
  margin: 0;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(30px, 3.2vw, 44px);
  font-weight: 700;
  letter-spacing: 0.14em;
  color: #171717;
`;

export const Sub = styled.div`
  margin-top: 14px;
  font-size: 12px;
  letter-spacing: 0.38em;
  text-transform: uppercase;
  color: ${c.pink};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(18px, 2.8vw, 26px);

  @media (min-width: 860px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const Block = styled.section`
  background: ${c.cardBg};
  color: ${c.ink};
  border-radius: 20px;
  padding: 26px 24px;
  border: 1px solid ${c.cardBorder};
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    inset: 10px;
    border-radius: 16px;
    border: 1px solid ${c.cardBorderPink};
    pointer-events: none;
  }

  @media (max-width: 520px) {
    padding: 22px 18px;

    &::after {
      inset: 9px;
      border-radius: 14px;
    }
  }
`;

export const BlockTitle = styled.h4`
  margin: 0 0 16px;
  font-size: 12px;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: ${c.gold};

  &::after {
    content: "";
    display: block;
    margin-top: 12px;
    height: 1px;
    background: rgba(201, 162, 39, 0.35);
  }
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 12px;
`;

export const Item = styled.li`
  display: grid;
  grid-template-columns: minmax(84px, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.1);

  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }

  @media (max-width: 380px) {
    grid-template-columns: minmax(72px, 1fr) auto;
    gap: 10px;
  }
`;

export const Key = styled.span`
  min-width: 0;
  font-size: 14px;
  color: ${c.muted};
`;

export const Val = styled.span`
  white-space: ${({ $wrap }) => ($wrap ? "normal" : "nowrap")};
  word-break: ${({ $wrap }) => ($wrap ? "break-word" : "normal")};
  overflow-wrap: ${({ $wrap }) => ($wrap ? "anywhere" : "normal")};

  font-size: 14px;
  font-weight: 600;
  text-align: right;
  color: #ffffff;

  /* IMPORTANT pentru cifre stabile */
  font-variant-numeric: tabular-nums;

  a {
    white-space: nowrap;
    color: #ffffff;
    text-decoration: none;
    border-bottom: 1px solid rgba(252, 154, 196, 0.65);
    padding-bottom: 2px;
    transition: border-color 0.2s ease;
  }

  a:hover {
    border-bottom-color: rgba(201, 162, 39, 0.75);
  }
`;

export const Actions = styled.div`
  margin-top: 18px;
`;

export const Btn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 22px;
  border-radius: 999px;
  border: 1px solid rgba(201, 162, 39, 0.75);
  color: #ffffff;
  background: transparent;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  text-decoration: none;
  transition:
    border-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    border-color: ${c.pink};
    color: ${c.pink};
  }
`;

export const Note = styled.p`
  margin-top: 18px;
  font-size: 13px;
  line-height: 1.7;
  color: ${c.muted};
`;
